import React from 'react';

import { PatientProps, usePatientContext } from '../../../../contexts/PatientContext';
import { Page, useExecutiveCheckupRouter } from '../../router/context';

import { PatientFormTemplate } from '../../../../templates/PatientFormTemplate';
import { useScheduleContext } from '../../../../contexts/ScheduleContext';
import { ScheduleItemPropsBuilder } from '../../../../models/Schedule';

import { useMainRouter } from '../../../../Router/pageComponents';

export function PatientFormPage() {
  const { patientSelected, addPatientList } = usePatientContext();
  const { changeSchedule, selectedItem: schedule } = useScheduleContext();
  const router = useExecutiveCheckupRouter();

  function createSchedule(props: { patientName: string; patientId: string }) {
    const { patientId, patientName } = props;

    const scheduleFactory = ScheduleItemPropsBuilder();
    scheduleFactory.setPatientName(patientName);
    scheduleFactory.setPatient(patientId);

    changeSchedule({ ...schedule, ...scheduleFactory.build() });
  }

  const handlePatient = async (patient: PatientProps) => {
    const createScheduleParams = {
      patientId: '',
      patientName: patient.name || ''
    };

    const { idPatient } = addPatientList(patient);
    createScheduleParams.patientId = idPatient || '';

    createSchedule(createScheduleParams);

    router.navigate(Page.PRODUCT_LIST);
  };

  const { goBack: mainRouterGoBack } = useMainRouter();

  function handleGoBack() {
    if (router.history.length === 1) return mainRouterGoBack();
    else router.goBack();
  }

  return <PatientFormTemplate patient={patientSelected} handlePatientSubmit={handlePatient} goBack={handleGoBack} />;
}
